import React from "react";

const SelectField = ({ extra, id, variant, label, disabled, children, value, onChange }) => {
    return (
        <div className={`${extra}`}>
            <label
                htmlFor={id}
                className={`text-sm text-navy-700 dark:text-white ${variant === "auth" ? "ml-1.5 font-medium" : "ml-3 font-bold"
                    }`}
            >
                {label}
            </label>
            <div className="mb-6 flex items-center justify-center">
                <select value={value} onChange={onChange} id={id} className="mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none">
                    {children}
                </select>
            </div>
        </div>
    )

}
export default SelectField